import { alpha, type Theme } from '@mui/material/styles';

/** Standard vertical gap between form fields */
export const FORM_FIELD_GAP = 2;

/** Gap between form sections */
export const FORM_SECTION_GAP = 3;

/** Shared sx for auth / marketing panels */
export function authPanelBackground(theme: Theme) {
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary.main;
  return {
    background: `
      radial-gradient(ellipse 80% 60% at 12% 18%, ${alpha(primary, 0.38)} 0%, transparent 55%),
      radial-gradient(ellipse 70% 50% at 88% 82%, ${alpha(secondary, 0.26)} 0%, transparent 50%),
      linear-gradient(165deg, #070B14 0%, #0C1222 48%, #101828 100%)
    `,
    position: 'relative' as const,
    overflow: 'hidden' as const,
  };
}

export function glassCardSx(theme: Theme) {
  const isLight = theme.palette.mode === 'light';
  return {
    borderRadius: 4,
    border: `1px solid ${isLight ? alpha('#0B1220', 0.08) : alpha('#E8EEF8', 0.1)}`,
    boxShadow: isLight
      ? `0 24px 56px ${alpha('#0B1220', 0.08)}, 0 2px 8px ${alpha('#0B1220', 0.04)}`
      : `0 24px 56px ${alpha('#000', 0.42)}`,
    bgcolor: isLight ? '#ffffff' : alpha(theme.palette.background.paper, 0.94),
  };
}
